import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=1b1d862e&scoped=true&"
import script from "./transform.vue?vue&type=script&lang=ts&"
export * from "./transform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d862e",
  null
  
)

export default component.exports